import React from "react";
import logo from "../assets/res/logo_infinite.svg";
import gamesIcon from "../assets/res/game.svg";
import searchIcon from "../assets/res/search.svg";
import appsIcon from "../assets/res/apps.svg";

const NAV_TABS = [
  { id: "Games", label: "Games", icon: gamesIcon },
  { id: "Apps", label: "Apps", icon: appsIcon },
  { id: "Search", label: "Search", icon: searchIcon },
];

// Desktop-only left navigation rail. Mirrors BottomNavigationBar's tabs and
// active-state styling; hidden below lg where the floating pill takes over.
const Sidebar = ({ page, setPage }) => {
  return (
    <aside
      className="hidden lg:flex flex-col flex-shrink-0 w-60 min-h-screen sticky top-0 self-start px-3 py-6 gap-2"
      style={{
        background: "rgba(1, 18, 38, 0.6)",
        borderRight: "1px solid rgba(255,255,255,0.07)",
      }}
    >
      <div className="flex flex-row items-center gap-2 px-3 mb-6">
        <img src={logo} width="40" height="40" alt="Infinite Mod" />
        <h1
          className="pressStart text-xl tracking-wider"
          style={{
            background:
              "linear-gradient(135deg, #ffffff 0%, #89d4f5 60%, #468faf 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            filter: "drop-shadow(0 0 8px rgba(70,143,175,0.5))",
          }}
        >
          MOD
        </h1>
      </div>

      {NAV_TABS.map(({ id, label, icon }) => {
        const isActive = page === id;
        return (
          <button
            key={id}
            onClick={() => setPage(id)}
            className="flex flex-row items-center gap-3 rounded-2xl px-4 py-3 transition-all duration-200 focus:outline-none"
            style={{
              background: isActive
                ? "linear-gradient(135deg, #468faf44, #01497c88)"
                : "transparent",
              boxShadow: isActive
                ? "0 0 16px rgba(70,143,175,0.35), inset 0 0 8px rgba(70,143,175,0.1)"
                : "none",
              border: isActive
                ? "1px solid rgba(70,143,175,0.4)"
                : "1px solid transparent",
            }}
          >
            <img
              src={icon}
              width={22}
              height={22}
              alt={label}
              style={{
                opacity: isActive ? 1 : 0.5,
                filter: isActive
                  ? "brightness(1.4) drop-shadow(0 0 4px rgba(70,143,175,0.8))"
                  : "none",
                transition: "all 0.2s ease",
              }}
            />
            <span
              className="semiBold text-base leading-none"
              style={{
                color: isActive ? "#89d4f5" : "rgba(255,255,255,0.5)",
                transition: "color 0.2s ease",
              }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </aside>
  );
};

export default Sidebar;
